import { useCallback } from 'react';
import { Text, Button } from '@mindbaz/ui-v2';
import { Trans } from '@lingui/react/macro';

import {
  StyledContainer,
  StyledNotListedLocationOutlinedIcon,
} from './styledComponents';

const Gone = () => {
  const handleClick = useCallback(
    () =>
      window.location.replace(
        import.meta.env.VITE_MINDBAZ_URL
          ? `${import.meta.env.VITE_MINDBAZ_URL}superset`
          : ''
      ),
    []
  );

  return (
    <StyledContainer>
      <StyledNotListedLocationOutlinedIcon />
      <Text variant="h1" weight="bold" align="center">
        <Trans id="gone_page.title">
          This Snapshot report is no longer available
        </Trans>
      </Text>
      <br />
      <Text align="center">
        <Trans id="gone_page.description1">
          Snapshot reports are accessible <strong>7 days</strong> after it was
          published.
        </Trans>
      </Text>
      <Text align="center">
        <Trans id="gone_page.description2">
          To have a complete view of your sendings, we invite you to discover
          Dashboards.
        </Trans>
      </Text>

      <br />
      <Button onClick={handleClick}>
        <Trans id="gone_page.link">Learn more about Dashboards</Trans>
      </Button>
    </StyledContainer>
  );
};

export default Gone;
